import { render, staticRenderFns } from "./WarrantList.vue?vue&type=template&id=584ccfbe&scoped=true"
import script from "./WarrantList.vue?vue&type=script&lang=js"
export * from "./WarrantList.vue?vue&type=script&lang=js"
import style0 from "./WarrantList.vue?vue&type=style&index=0&id=584ccfbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584ccfbe",
  null
  
)

export default component.exports